import React, { useState, useEffect } from 'react'
import {
  Panel,
  InputNumber,
  Grid,
  Row,
  Col,
  Input,
  InputGroup,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  SelectPicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
} from 'rsuite'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import InputNumberForm from '../../../../components/forms/input/InputNumberForm'
import NumberFormat from 'react-number-format'
import InputForm from '../../../../components/forms/input/InputForm'

export default function BackgroundOfElderlyForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const [percenList, setPercenList] = useState({})
  const [activity, setActivity] = useState()
  const [activityForms, setActivityForms] = useState([])
  const [otherDisease, setOtherDisease] = useState([])

  useEffect(() => {
    let percenList = {}

    percenList[schema.elderlySocialCount.name] = schema.elderlySocialCount.value
    percenList[schema.elderlySocialJoinActivity.name] = schema.elderlySocialJoinActivity.value
    percenList[schema.elderlySocialAccident.name] = schema.elderlySocialAccident.value

    setPercenList(percenList)

    let activityFs = [...schema.activityList.value]
    let otherDisease = [...schema.elderlyOtherDisease.value]

    setValue(schema.activity.name, schema.activity.value || 'N')
    setActivity(schema.activity.value || 'N')
    setValue(schema.activityList.name, activityFs)
    setActivityForms(activityFs)

    setValue(schema.elderlyOtherDisease.name, otherDisease)
    setOtherDisease(otherDisease)
  }, [schema])

  const createActivity = () => {
    return { activityName: '', activityResult: '' }
  }

  const addNewActivity = () => {
    let activityFs = [...activityForms]

    activityFs.push(createActivity())
    setActivityForms(activityFs)
  }

  const calculatePercent = (name) => {
    var value = percenList[name]

    return value ? ((value * 100) / percenList[schema.elderlySocialCount.name]).toFixed(2) : ''
  }

  const onActivityChange = (value) => {
    setValue(schema.activity.name, value)
    setActivity(value)
  }

  const onDeleteActivity = (index) => {
    let activitys = [...activityForms]

    activitys.splice(index, 1)

    setValue(schema.activityList.name, activitys)
    setActivityForms(activitys)
  }

  const onAddOtherDisease = () => {
    let other = [...otherDisease]

    other.push({ name: '', amount: '' })
    setValue(schema.elderlyOtherDisease.name, other)
    setOtherDisease(other)
  }

  const onDeleteOtherDisease = (index) => {
    let other = [...otherDisease]
    console.log('index', index, 'other', other)
    other.splice(index, 1)

    setValue(schema.elderlyOtherDisease.name, other)
    setOtherDisease(other)
  }

  const getYearOption = () => {
    var newYearOption = []
    var currentYear = new Date().getFullYear()
    currentYear = currentYear + 543
    for (let i = 0; i < 10; i++) {
      let year = {
        label: (currentYear - i).toString(),
        value: currentYear - i,
      }
      newYearOption.push(year)
    }
    // console.log(newYearOption)
    return newYearOption
  }

  const renderActivityInputForm = activityForms.map((item, index) => {
    return (
      <div key={index}>
        <Panel bordered style={{ marginBottom: 5 }}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
              <ControlLabel>
                <b>
                  {schema.activityForm.activity.label} {index + 1}
                </b>
              </ControlLabel>
              <Input
                defaultValue={item.activityName}
                name={schema.activityForm.activity.name + '_' + index}
                placeholder={schema.activityForm.activity.hint}
                inputRef={register(schema.activityForm.activity.validators)}
                onChange={(value) => {
                  let activitys = [...activityForms]

                  activitys[index].activityName = value

                  setValue(schema.activityList.name, activitys)
                  setActivityForms(activitys)
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={schema.activityForm.result}
                name={schema.activityForm.result.name + '_' + index}
                value={item.activityResult}
                rows={3}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                onChange={(value) => {
                  let activitys = [...activityForms]

                  activitys[index].activityResult = value

                  setValue(schema.activityList.name, activitys)
                  setActivityForms(activitys)
                }}
              />
              {/* <ControlLabel>{schema.activityForm.result.label}</ControlLabel>
              <Input
                componentClass="textarea"
                rows={3}
                name={schema.activityForm.result.name + '_' + index}
                defaultValue={item.activityResult}
                placeholder={schema.activityForm.result.hint}
                inputRef={register(schema.activityForm.result.validators)}
                onChange={(value) => {
                  let activitys = [...activityForms]

                  activitys[index].activityResult = value

                  setValue(schema.activityList.name, activitys)
                  setActivityForms(activitys)
                }}
              /> */}
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={
                  <Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />
                }
                onClick={(e) => onDeleteActivity(index)}
              >
                ลบกิจกรรม
              </IconButton>
            </Col>
          </Row>
        </Panel>
      </div>
    )
  })

  const renderInputDisease = otherDisease.map((item, index) => {
    const disease = schema.elderlyOtherDisease
    const diseaseName = disease.diseaseName.name + '_' + index
    const diseaseValueName = disease.diseaseValue.name + '_' + index

    return (
      <Row style={{ marginTop: 5 }}>
        {errors[diseaseName] && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
            <ErrorMessage error={errors[diseaseName]} />
          </Col>
        )}
        {errors[diseaseValueName] && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
            <ErrorMessage error={errors[diseaseValueName]} />
          </Col>
        )}
        <Col xs={1} sm={1} md={1} lg={1}>
          2.{index + 8}
        </Col>
        <Col xs={22} sm={22} md={7} lg={7}>
          <Input
            name={diseaseName}
            disabled={disease.diseaseName.disabled}
            value={item.name}
            placeholder={disease.diseaseName.hint}
            inputRef={register(disease.diseaseName.validators)}
            onChange={(value) => {
              var other = otherDisease
              other[index].name = value
              setOtherDisease(other)
              setValue(diseaseName, value)
              clearErrors(diseaseName)
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6}>
          <InputGroup>
            <InputGroup.Addon>{disease.diseaseValue.preLabel}</InputGroup.Addon>
            <Controller
              key={diseaseValueName}
              name={diseaseValueName}
              control={control}
              rules={isValidators(disease.diseaseValue.validators)}
              defaultValue={item.amount}
              render={(props) => {
                return (
                  // <InputNumber
                  //   disabled={disease.diseaseValue.disabled}
                  //   value={props.value}
                  //   placeholder={disease.diseaseValue.hint}
                  //   onChange={(value) => {
                  <NumberFormat
                    className="rs-input"
                    disabled={disease.diseaseValue.disabled}
                    thousandSeparator={true}
                    value={props.value}
                    placeholder={disease.diseaseValue.hint}
                    onValueChange={(e) => {
                      let value = e.floatValue
                      var other = otherDisease
                      other[index].amount = value
                      setOtherDisease(other)
                      setValue(diseaseValueName, value)
                      clearErrors(diseaseValueName)
                    }}
                  />
                )
              }}
            />
            <InputGroup.Addon>{disease.diseaseValue.postLabel}</InputGroup.Addon>
          </InputGroup>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6}>
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
            onClick={(e) => onDeleteOtherDisease(index)}
          >
            ลบโรค
          </IconButton>
        </Col>
      </Row>
    )
  })

  const inputNumberGroup = (obj, col) => {
    return (
      <Row>
        {errors[obj.name] && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
            <ErrorMessage error={errors[obj.name]} />
          </Col>
        )}

        {obj.label && (
          <Col
            xs={24}
            sm={24}
            md={col ? col[0] : 24}
            lg={col ? col[0] : 24}
            style={{ marginTop: 5 }}
          >
            <p style={{ marginTop: 5 }}>{requiredFiled(obj.validators, obj.label)}</p>
          </Col>
        )}
        <Col xs={24} sm={24} md={col ? col[1] : 24} lg={col ? col[1] : 24} style={{ marginTop: 5 }}>
          <InputGroup>
            <InputGroup.Addon>
              <p>{obj.preLabel}</p>
            </InputGroup.Addon>
            <Controller
              key={obj.name}
              name={obj.name}
              control={control}
              rules={isValidators(obj.validators)}
              defaultValue={obj['value']}
              render={(props) => {
                return (
                  // <InputNumber
                  //   disabled={obj.disabled}
                  //   defaultValue={props.value}
                  //   placeholder={obj.hint}
                  //   onChange={(value) => {
                  <NumberFormat
                    className="rs-input"
                    disabled={obj.disabled}
                    thousandSeparator={true}
                    value={props.value}
                    placeholder={obj.hint}
                    onValueChange={(e) => {
                      let value = e.floatValue
                      var percenListAll = percenList
                      percenListAll[obj.name] = value
                      // console.log(percenListAll)
                      setPercenList(percenListAll)
                      setValue(obj.name, value)
                      clearErrors(obj.name)
                    }}
                  />
                )
              }}
            />
            <InputGroup.Addon>
              <p>{obj.postLabel}</p>
            </InputGroup.Addon>
          </InputGroup>
        </Col>
      </Row>
    )
  }

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <FormGroup>
            <Row>
              <Col>
                {requiredFiled(
                  schema.activity.validators,
                  schema.activity.label
                    .replace('{village}', schema.villageInfo.village)
                    .replace('{subDistrict}', schema.villageInfo.subDistrict)
                    .replace('{district}', schema.villageInfo.district)
                    .replace('{province}', schema.villageInfo.province)
                )}
              </Col>
              <Col style={{ marginLeft: 25 }}>
                <Controller
                  key={schema.activity.name}
                  name={schema.activity.name}
                  control={control}
                  rules={isValidators(schema.activity.validators)}
                  defaultValue={schema.activity.value || 'N'}
                  render={() => {
                    return (
                      <RadioGroup value={activity} onChange={(value) => onActivityChange(value)}>
                        {schema.activity.options.map((item) => {
                          return (
                            <Radio value={item.value}>
                              {item.label}
                              {activity == 'Y' && activity == item.value && (
                                <text>
                                  <b>&nbsp;{schema.villageInfo.village}</b>{' '}
                                  {schema.activityYear.label}
                                  &nbsp;
                                  <Input
                                    maxLength={
                                      getMaxLengthData(schema.activityYear.validators).value
                                    }
                                    style={{ width: 60 }}
                                    name={schema.activityYear.name}
                                    placeholder={
                                      schema.activityYear.hint || schema.activityYear.label
                                    }
                                    defaultValue={schema.activityYear.value}
                                    inputRef={register(schema.activityYear.validators)}
                                  />
                                  &nbsp; {schema.activityMember.preLabel} &nbsp;
                                  <Input
                                    name={schema.activityMember.name}
                                    placeholder={
                                      schema.activityMember.hint || schema.activityMember.label
                                    }
                                    style={{ width: 100 }}
                                    defaultValue={schema.activityMember.value}
                                    inputRef={register(schema.activityMember.validators)}
                                  />
                                  &nbsp; {schema.activityMember.postLabel}{' '}
                                  {schema.activityLeader.preLabel} &nbsp;
                                  <Input
                                    name={schema.activityLeader.name}
                                    placeholder={
                                      schema.activityLeader.hint || schema.activityLeader.label
                                    }
                                    style={{ width: 240 }}
                                    defaultValue={schema.activityLeader.value}
                                    inputRef={register(schema.activityLeader.validators)}
                                  />
                                  &nbsp; {schema.activityLeader.postLabel} &nbsp;
                                </text>
                              )}
                            </Radio>
                          )
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>

            <Row>
              <p>{schema.activityList.label}</p>
              <CustomIconMessageInfo contents={schema.activityList.description} />
              <Controller
                key={schema.activityList.name}
                name={schema.activityList.name}
                control={control}
                rules={isValidators(schema.activityList.validators)}
                defaultValue={activityForms}
              />
              {renderActivityInputForm}
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                  onClick={(e) => addNewActivity()}
                  style={{ marginRight: 5 }}
                >
                  เพิ่มกิจกรรม
                </IconButton>
              </Col>
            </Row>

            <Row>
              <CKEditorFrom
                schema={schema.activityProblem}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                {schema.elderlyInfoText
                  .replace('{village}', schema.villageInfo.village)
                  .replace('{subDistrict}', schema.villageInfo.subDistrict)
                  .replace('{district}', schema.villageInfo.district)
                  .replace('{province}', schema.villageInfo.province)}
              </Col>
              <Col style={{ marginTop: 10 }}>
                <b>{schema.elderlyCountTypeText}</b>
              </Col>
              <Col>
                <Panel bordered style={{ marginBottom: 10 }}>
                  <Row>
                    <b>{schema.elderlyCountText}</b>
                  </Row>
                  <Row>
                    <InputNumberForm
                      schema={schema.allPeople}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={8}
                      inputMdlg={6}
                    />
                    <InputNumberForm
                      schema={schema.elderlyPeople}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={8}
                      inputMdlg={6}
                    />
                  </Row>

                  <Row>
                    <b>{schema.elderlyTypeText}</b>
                  </Row>
                  <Row>
                    <InputNumberForm
                      schema={schema.elderlySocialGroup}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={12}
                      inputMdlg={6}
                    />
                    <InputNumberForm
                      schema={schema.elderlyHomeGroup}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={12}
                      inputMdlg={6}
                    />
                    <InputNumberForm
                      schema={schema.elderlyBedStickGroup}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={12}
                      inputMdlg={6}
                    />
                  </Row>

                  <Row>
                    <Form layout="inline" style={{ marginTop: 10 }}>
                      <FormGroup>
                        <ControlLabel>
                          {requiredFiled(
                            schema.elderlyTypeSourceInfo.validators,
                            schema.elderlyTypeSourceInfo.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyTypeSourceInfo.name}
                          name={schema.elderlyTypeSourceInfo.name}
                          control={control}
                          rules={isValidators(schema.elderlyTypeSourceInfo.validators)}
                          defaultValue={schema.elderlyTypeSourceInfo.value}
                          render={(props) => {
                            return (
                              <FormControl
                                value={props.value}
                                placeholder={schema.elderlyTypeSourceInfo.hint}
                                onChange={(value) => {
                                  setValue(schema.elderlyTypeSourceInfo.name, value)
                                  clearErrors(schema.elderlyTypeSourceInfo.name)
                                }}
                              />
                            )
                          }}
                        />

                        <ControlLabel style={{ marginLeft: 10 }}>
                          {requiredFiled(
                            schema.elderlyTypeSourceMonth.validators,
                            schema.elderlyTypeSourceMonth.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyTypeSourceMonth.name}
                          name={schema.elderlyTypeSourceMonth.name}
                          control={control}
                          rules={isValidators(schema.elderlyTypeSourceMonth.validators)}
                          defaultValue={schema.elderlyTypeSourceMonth.value}
                          render={(props) => {
                            return (
                              <SelectPicker
                                size="lg"
                                style={{ width: 120, marginLeft: 10 }}
                                searchable={true}
                                value={props.value}
                                data={schema.elderlyTypeSourceMonth.options}
                                placeholder={schema.elderlyTypeSourceMonth.hint}
                                onChange={(value) => {
                                  // console.log(value)
                                  setValue(schema.elderlyTypeSourceMonth.name, value)
                                }}
                              />
                            )
                          }}
                        />

                        <ControlLabel style={{ marginLeft: 10 }}>
                          {requiredFiled(
                            schema.elderlyTypeSourceInfoYear.validators,
                            schema.elderlyTypeSourceInfoYear.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyTypeSourceInfoYear.name}
                          name={schema.elderlyTypeSourceInfoYear.name}
                          control={control}
                          rules={isValidators(schema.elderlyTypeSourceInfoYear.validators)}
                          defaultValue={schema.elderlyTypeSourceInfoYear.value}
                          render={(props) => {
                            return (
                              <SelectPicker
                                size="lg"
                                style={{ marginLeft: 10 }}
                                searchable={true}
                                value={props.value}
                                // data={getYearOption()}
                                data={schema.elderlyTypeSourceInfoYear.options}
                                placeholder={schema.elderlyTypeSourceInfoYear.hint}
                                onChange={(value) => {
                                  setValue(schema.elderlyTypeSourceInfoYear.name, value)
                                }}
                              />
                            )
                          }}
                        />
                      </FormGroup>
                    </Form>
                  </Row>
                </Panel>
              </Col>

              <Col style={{ marginTop: 10 }}>
                <b>{schema.elderlyHealthText}</b>
              </Col>

              <Col>
                <Panel bordered style={{ marginBottom: 10 }}>
                  <Row>
                    <CustomIconMessageInfo contents={schema.elderlyHealth.description} />
                  </Row>
                  <Row>
                    <InputNumberForm
                      schema={schema.elderlyNoHealthProblem}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={8}
                      inputMdlg={6}
                    />
                    <Row>
                      <InputNumberForm
                        schema={schema.elderlyHealthProblem}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                    </Row>

                    <Row style={{ marginLeft: 10 }}>
                      <InputNumberForm
                        schema={schema.elderlyHypertension}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyDiabetes}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyDegenerative}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyEmphysema}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyCoronaryHeartDisease}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyParalysis}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyDepression}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />

                      <Controller
                        key={schema.elderlyOtherDisease.name}
                        name={schema.elderlyOtherDisease.name}
                        control={control}
                        defaultValue={otherDisease}
                      />
                      {renderInputDisease}
                      <Col style={{ marginTop: 10, marginBottom: 10 }}>
                        <IconButton
                          appearance="ghost"
                          disabled={
                            otherDisease.length > 0 && !otherDisease[otherDisease.length - 1].name
                          }
                          icon={
                            <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                          }
                          onClick={(e) => onAddOtherDisease()}
                          style={{ marginRight: 5 }}
                        >
                          เพิ่มโรค
                        </IconButton>
                      </Col>
                    </Row>
                    <Row>
                      <InputNumberForm
                        schema={schema.elderlyHealthPromotion}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                    </Row>
                    <Row style={{ marginLeft: 10 }}>
                      <InputNumberForm
                        schema={schema.elderlyHealthExercise}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                      <InputNumberForm
                        schema={schema.elderlyHealthRightFood}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        labelMdLg={8}
                        inputMdlg={6}
                      />
                    </Row>
                  </Row>

                  <Row>
                    <Form layout="inline" style={{ marginTop: 10 }}>
                      <FormGroup>
                        <ControlLabel>
                          {requiredFiled(
                            schema.elderlyHealthSourceInfo.validators,
                            schema.elderlyHealthSourceInfo.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyHealthSourceInfo.name}
                          name={schema.elderlyHealthSourceInfo.name}
                          control={control}
                          rules={isValidators(schema.elderlyHealthSourceInfo.validators)}
                          defaultValue={schema.elderlyHealthSourceInfo.value}
                          render={(props) => {
                            return (
                              <FormControl
                                value={props.value}
                                placeholder={schema.elderlyHealthSourceInfo.hint}
                                onChange={(value) => {
                                  setValue(schema.elderlyHealthSourceInfo.name, value)
                                  clearErrors(schema.elderlyHealthSourceInfo.name)
                                }}
                              />
                            )
                          }}
                        />

                        <ControlLabel style={{ marginLeft: 10 }}>
                          {requiredFiled(
                            schema.elderlyHealthSourceMonth.validators,
                            schema.elderlyHealthSourceMonth.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyHealthSourceMonth.name}
                          name={schema.elderlyHealthSourceMonth.name}
                          control={control}
                          rules={isValidators(schema.elderlyHealthSourceMonth.validators)}
                          defaultValue={schema.elderlyHealthSourceMonth.value}
                          render={(props) => {
                            return (
                              <SelectPicker
                                size="lg"
                                style={{ width: 120, marginLeft: 10 }}
                                searchable={true}
                                value={props.value}
                                data={schema.elderlyHealthSourceMonth.options}
                                placeholder={schema.elderlyHealthSourceMonth.hint}
                                onChange={(value) => {
                                  // console.log(value)
                                  setValue(schema.elderlyHealthSourceMonth.name, value)
                                }}
                              />
                            )
                          }}
                        />

                        <ControlLabel style={{ marginLeft: 10 }}>
                          {requiredFiled(
                            schema.elderlyHealthSourceInfoYear.validators,
                            schema.elderlyHealthSourceInfoYear.label
                          )}
                        </ControlLabel>
                        <Controller
                          key={schema.elderlyHealthSourceInfoYear.name}
                          name={schema.elderlyHealthSourceInfoYear.name}
                          control={control}
                          rules={isValidators(schema.elderlyHealthSourceInfoYear.validators)}
                          defaultValue={schema.elderlyHealthSourceInfoYear.value}
                          render={(props) => {
                            return (
                              <SelectPicker
                                size="lg"
                                style={{ marginLeft: 10 }}
                                searchable={true}
                                value={props.value}
                                data={schema.elderlyHealthSourceInfoYear.options}
                                placeholder={schema.elderlyHealthSourceInfoYear.hint}
                                onChange={(value) => {
                                  setValue(schema.elderlyHealthSourceInfoYear.name, value)
                                }}
                              />
                            )
                          }}
                        />
                      </FormGroup>
                    </Form>
                  </Row>
                </Panel>
              </Col>

              <Col style={{ marginTop: 10 }}>
                <b>{schema.elderlySocialInfoText}</b>
              </Col>
              <Col>
                <Panel bordered style={{ marginBottom: 10 }}>
                  <Row>{inputNumberGroup(schema.elderlySocialCount, [8, 6])}</Row>
                  <Row>{inputNumberGroup(schema.elderlySocialJoinActivity, [8, 6])}</Row>
                  <Row>{inputNumberGroup(schema.elderlySocialAccident, [8, 6])}</Row>
                </Panel>
              </Col>
            </Row>

            <Row>
              <Form layout="inline">
                <FormGroup>
                  <ControlLabel>{schema.elderlySocialInfoSummaray.preLabel}</ControlLabel>
                  <FormControl
                    disabled
                    value={percenList[schema.elderlySocialCount.name]}
                    style={{ width: 70 }}
                  />
                  <ControlLabel>
                    &nbsp; &nbsp; {schema.elderlySocialInfoSummaray.postLabel}
                  </ControlLabel>

                  <ControlLabel>
                    &nbsp; &nbsp; {schema.elderlySocialInfoPercent.preLabel}
                  </ControlLabel>
                  <FormControl
                    disabled
                    value={calculatePercent(schema.elderlySocialJoinActivity.name)}
                    style={{ width: 70 }}
                  />
                  <text>{schema.elderlySocialInfoPercent.postLabel}</text>
                </FormGroup>
              </Form>

              {/* <Col>
                <p>
                  {schema.elderlySocialInfoFooterText
                    .replace(
                      '{elderlySocialJoinActivity}',
                      percenList[schema.elderlySocialCount.name]
                    )
                    .replace('{percent}', calculatePercent(schema.elderlySocialJoinActivity.name))}
                </p>
              </Col> */}
              <CKEditorFrom
                schema={schema.elderlySocialInfoFooter}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Row>
            <Row>
              <CKEditorFrom
                schema={schema.otherProblems}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Row>
          </FormGroup>
        </Grid>
      </Panel>
    </>
  )
}
